const escrowWalletNL = {
    "view": {
        "title": "Beheer Uw Escrow Wallet",
        "descriptionParagraph1": "Gelden worden ingehouden om veiligheid en transparantie te waarborgen tijdens het verificatieproces. Voor gemarkeerde tracks wordt een vergoeding van <strong>15 €</strong> per track in escrow gehouden om de track op de whitelist te zetten voor levering aan Spotify. Deze gelden worden terugbetaald zodra de artiesten van de track als legitiem zijn geverifieerd.",
        "descriptionParagraph2": "Gebruik de onderstaande tabel om alle escrow-transacties te bekijken. Voor meer details, <1><strong>Leer Meer</strong></1>",
        "label": {
            "totalWithheld": "Totaal Ingehouden",
            "totalRefunds": "Totaal Terugbetalingen"
        },
        "escrowPayments": {
            "title": "Escrow Betalingen",
            "table": {
                "column": {
                    "paymentId": "Betalings-ID",
                    "releaseName": "Release",
                    "amount": "Bedrag",
                    "paymentDate": "Betaaldatum",
                    "paymentAgreement": "Betalingsovereenkomst",
                    "refundProcessed": "Terugbetaling Verwerkt",
                    "requestRefund": "Terugbetaling Aanvragen",
                    "details": "Details"
                },
                "placeholder": {
                    "search": "Zoeken..."
                },
                "button": {
                    "download": "Downloaden",
                    "exportCsv": "Exporteer CSV",
                    "view": "Bekijken",
                    "requestRefund": "Terugbetaling Aanvragen"
                },
                "label": {
                    "notAvailable": "Niet Beschikbaar"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Terugbetaling Aanvragen",
                        "body": {
                            "description": "Weet u zeker dat u een terugbetaling voor deze betaling wilt aanvragen?",
                            "note": "Houd er rekening mee dat dit verzoek onderhevig is aan beoordeling door de beheerder en, indien goedgekeurd, zal worden toegevoegd als een verklaring waarvoor u een factuur kunt uitgeven."
                        },
                        "button": {
                            "confirm": "Bevestigen",
                            "cancel": "Annuleren"
                        },
                        "message": {
                            "success": "Terugbetalingsverzoek succesvol ingediend!",
                            "error": "Er is iets misgegaan, probeer het later opnieuw!"
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Escrow Betalingsspecificatie",
            "table": {
                "column": {
                    "paymentId": "Betalings-ID",
                    "trackName": "Track",
                    "amount": "Bedrag",
                    "paymentDate": "Betaaldatum"
                }
            }
        },
        "escrowRefunds": {
            "title": "Escrow Terugbetalingen",
            "table": {
                "column": {
                    "refundId": "Terugbetalings-ID",
                    "paymentId": "Betalings-ID",
                    "release": "Release",
                    "amount": "Bedrag",
                    "requestDate": "Aanvraagdatum",
                    "status": "Status"
                },
                "label": {
                    "pending": "In Behandeling",
                    "approved": "Goedgekeurd",
                    "rejected": "Afgewezen"
                },
                "tooltip": {
                    "pending": "Uw terugbetalingsverzoek is momenteel in behandeling voor beoordeling door de beheerder en zal binnenkort worden verwerkt.",
                    "approved": "Uw terugbetalingsverzoek is goedgekeurd en er is een verklaring toegevoegd voor het terugbetalingsbedrag.",
                    "rejected": "Uw terugbetalingsverzoek is afgewezen door de beheerder, u kunt opnieuw een terugbetaling aanvragen."
                },
                "placeholder": {
                    "search": "Zoeken..."
                },
                "button": {
                    "exportCsv": "Exporteer CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transactie Succesvol :)",
            "description": "Escrow Betaling is succesvol voltooid, de betreffende release zal binnenkort op de whitelist worden gezet!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transactie Geannuleerd :(",
            "description": "De transactie is geannuleerd... Probeer het later opnieuw!",
            "button": {
                "returnToDashboard": "Terug naar Dashboard"
            }
        }
    }
};

export default escrowWalletNL;